import { Autocomplete, Button, Checkbox, CircularProgress, Grid, TextField } from "@mui/material";
import { PAYMENT_STATUS_CODE } from "Components/Constants/PaymentStatusCode";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openSnackbar } from "../../../../Redux/Actions/snackbarActions";
import invoiceService from "../../../../Service/Invoice/invoice.service";
import SalesReturnService from "../../../../Service/Invoice/SalesReturn.service";
import Loading from "../../../MUI_components/loading";
import SalesReturnTable from "./invoiceDataTable";
import ReturnDataTable from "./returnDataTable";
import BasicDialog from "Components/MUI_components/Dialog-Box/basicDialog";
import { pageStyle } from "Components/Print/printPagesStyles";
import Print from "../Receipt/salesReturnBill/DotMatrix"
import PosPrint from "../Receipt/salesReturnBill/posBill"


import { SALES_RETURN_TYPE } from "Components/Constants/SalesReturnType";
import { useReactToPrint } from "react-to-print";
import { PRINT_TYPE } from "Components/Constants/PrintType";


export default function ReturnWithBill(props) {
  const { setOpen, setSubmitted, parentCallback } = props;
  const dispatch = useDispatch();
  const stockLocations = useSelector((state) => state.location);
  //const [stock, setStock] = useState(initStockValue);
  const printComponent = React.createRef();
  const form = React.createRef();

  const [loading, setLoading] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoice, setInvoice] = useState({});
  const [returnedData, setReturnedData] = useState({}); //Already returned data
  const [salesReturnAndDeliveredItemGroupBy, setSalesReturnAndDeliveredItemGroupBy] = useState({}); //Already returned data and deliverd Data based on Item Code

  const [invoiceForReturn, setInvoiceForReturn] = useState([]);
  const [returnedItem, setReturnedItem] = useState(null);
  const [returnedQty, setReturnedQty] = useState("");
  const [returnData, setReturnData] = useState([]);
  const [openBillPrint, setOpenBillPrint] = useState(false);
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);
  const [returnedDiscount, setReturnedDiscount] = useState(0);
  const [stock, setStock] = useState()
  const [cashPay, setCashPay] = useState(false);
  const [disabledForSingle, setDisabledForSingle] = useState(false);
  const [deliverData, setDeliverty] = useState([]);

  const computerReceiptPrintComponent = React.useRef(null);
  const billReceiptPrintComponent = React.useRef(null);
  const paymentTypes = useSelector((state) => state.paymentType);
  const [value, setvalue] = useState();
  const [send,setSend] = useState(false)
  const [submittedData, setSubmittedData] = useState("");

  const handlePrintPOS = useReactToPrint({

    content: () => billReceiptPrintComponent.current,
    onAfterPrint: () => {
      setOpenBillPrint(false);
      setOpen(false);
    },
    pageStyle: pageStyle.receipt,
  });

  const handlePrintDotMatrix = useReactToPrint({
    content: () => computerReceiptPrintComponent.current,
    onAfterPrint: (values) => {
      setOpenBillPrint(false);
      setOpen(false);

    },
    pageStyle: pageStyle.a4,
  });


  const handleStockDataChange = (e) => {
    const { name } = e.target;
    const { value } = e.target;

    setStock({
      ...stock,
      [name]: value,

    });
  };

  const handleDiscountChange = (event) => {
    setReturnedDiscount(event.target.value);
  }

  const addingReturnedItems = (e) => {
    const { discount, totalAmount } = reverseDiscount(
      returnedItem,
      invoice.subTotalAmount,
      invoice.billDiscount,
      returnedQty

    );
    setReturnData([
      ...returnData,
      {
        itemMaster: returnedItem.itemMaster,
        unitSoldPrice: returnedItem.unitSoldPrice,
        quantity: returnedQty ? returnedQty : 1,
        discount: discount,
        totalAmount: totalAmount,
        itemCode: returnedItem.itemMaster.code,
        locationCode: defaultLocationSelected.location.code,
        costPrice: returnedItem.itemMaster.costPrice,
        retailPrice: returnedItem.itemMaster.retailPrice,
        stockCode: returnedItem.stockCode
      },
    ]);
    const temp = invoiceForReturn.map((value) =>
      value.code === returnedItem.code
        ? {
          ...value,
          quantity: value.quantity - (returnedQty ? returnedQty : 1),
        }
        : value
    );
    setInvoiceForReturn(temp);
    setReturnedItem(null);
  };

  const reverseDiscount = (selectedItem, subtotal, billDiscount) => {
    const returningQuantity = returnedQty ? returnedQty : 1

    // select sold out qty from selected invoice
    let qty = invoice.stockHistories.filter(
      (value) => value.code === selectedItem.code
    );
    const quantity = qty[0].quantity;
    const returningItemsTotalLineDiscount = (selectedItem.discountTotal / selectedItem.quantity) * returningQuantity;
    // -------------------------------
    const price =
      returnedItem.retailPrice - selectedItem.discountTotal / quantity;
    let billDiscountPortionForEachItem = (price / subtotal) * billDiscount;

    let discount =
      parseFloat(selectedItem.discountTotal / quantity) +
      parseFloat(billDiscountPortionForEachItem);
    discount = discount * (returnedQty ? returnedQty : 1);
    const totalAmount =
      returnedItem.retailPrice * (returnedQty ? returnedQty : 1) - discount;

    return { discount: discount, totalAmount: totalAmount };
  };

  const getInvoiceNumber = (e) => {
    const { value } = e.target;
    setInvoiceNumber(value);
  };

  const handleReset = () => {
    setReturnData([]);
    setInvoiceForReturn(invoice.stockHistories);
  };

  const printTypeRef = useRef(PRINT_TYPE.POS);

  const fetchInvoice = async () => {
    setLoading(true);
    try {
      const res = await invoiceService.getInvoiceForSalesReturnSameLocation(invoiceNumber);

      if (res?.invoice == undefined) {
        dispatch(openSnackbar(true, "info", "Invoice not found"));
        setLoading(false);
        return;
    }

      console.log(res);
      setvalue(res.invoice.customer)
      setInvoice(res.invoice);
      setReturnedData(res.salesReturn);
      setSalesReturnAndDeliveredItemGroupBy(res.salesReturnAndDeliveredItemGroupBy);
      setDeliverty(res.deliveryNote)

      let stockForReturn = res.invoice ? res.invoice.stockHistories : null;
      if (res.invoice.stockHistories && !Array.isArray(res.salesReturnAndDeliveredItemGroupBy)) {
        stockForReturn = res.invoice.stockHistories.map((stockHistory) => {
          return {
            ...stockHistory,
            // quantity: stockHistory.quantity - (parseFloat(res.salesReturnAndDeliveredItemGroupBy[stockHistory.stockCode]) ?? 0)
            quantity: parseFloat(res.salesReturnAndDeliveredItemGroupBy[stockHistory.stockCode])


          }
        })
      }


      setInvoiceForReturn(stockForReturn);

    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
    setLoading(false);
  };

  const subTotalAmount = returnData
  .map((data) => data.totalAmount)
  .reduce((totalAmount, i) => totalAmount + i, 0);

let totalAmount = subTotalAmount - returnedDiscount;
  // const handleSubmit = () => {
    const handleSubmit = async () => {
      setDisabledForSingle(true);
      setLoading(true);
      try {
        const subTotal = returnData
          .map((data) => data.totalAmount)
          .reduce((totalAmount, i) => totalAmount + i, 0);
        const totalAmount = subTotal - returnedDiscount;
        const salesReturn = {
          customerCode: invoice.customerCode,
          invoiceCode: invoice.code,
          subTotalAmount: subTotal,
          discountAmount: returnedDiscount,
          totalAmount: totalAmount,
          paidStatus: cashPay ? PAYMENT_STATUS_CODE.CASH_PAY : PAYMENT_STATUS_CODE.PAYMENT_NOT_DONE,
          returnType: SALES_RETURN_TYPE.SALES_RETURN_WITH_BILL
        }
  
        const data = { ...salesReturn, returnData,send };
        console.log('data', data);
        const res = await SalesReturnService.create(data);
        setSubmittedData(res.submittedData)
        
        setSubmitted  && setSubmitted((prev) => !prev);
        let returnCode = res.submittedData.code;
        send && sendDataToParent(
          totalAmount,
          returnCode
        );
        if(printTypeRef.current == PRINT_TYPE.POS){
          handlePrintPOS();
        }else {
          handlePrintDotMatrix();
        }
       // setOpenBillPrint(false)
        dispatch(
          openSnackbar(true, "success", `Sales return added successfully`)
        );
        
      } catch (e) {
        dispatch(openSnackbar(true, "error", e));
      }
      setLoading(false);
      setTimeout(() => {
        setDisabledForSingle(false);
      }, 10000); // 10 seconds
  




    setTimeout(() => {
      setDisabledForSingle(false);
    }, 10000); // 10 seconds

  };
  const handleChecked = (e, target) => {
    setCashPay(target);
  };
  const sendDataToParent = (totalAmount,returnCode) => {
    parentCallback(totalAmount,returnCode);
  };

  return (
    <>
      <br />
      <Grid container spacing={3} justify="center">
        <Grid item sm={12} xs={12}>
          <Grid container spacing={1}>
            <Grid item md={6}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Invoice Number"
                value={invoiceNumber}
                onChange={getInvoiceNumber}
              />
            </Grid>
            <Grid item md={6}>
              <Button
                variant="contained"
                disabled={!invoiceNumber}
                color="primary"
                onClick={fetchInvoice}
              >
                Find
              </Button>
            </Grid>
          </Grid>

          <div className="mt mb">
            {loading ? (
              <Loading height={100} text="Loading invoice data.." />
            ) : (
              <SalesReturnTable data={invoice} returnedData={returnedData} deliveryData={deliverData} />
            )}
          </div>

          <br />

          <form
            autoComplete="off"
            ref={form}
            onKeyPress={(e) => {
              if (e.key === "Enter")
                form.current.reportValidity() && addingReturnedItems();
            }}
          >
            <Grid container spacing={1}>
              <Grid item md={6}>
                <Autocomplete
                  options={
                    invoiceForReturn
                      ? invoiceForReturn.filter((val) => val.quantity > 0)
                      : []
                  }
                  value={returnedItem}
                  onChange={(event, newValue) => setReturnedItem(newValue)}
                  getOptionLabel={(option) =>
                    option.stockCode + " - "+
                    option.itemMaster?.name +
                    " - " +
                    option.itemMaster?.barcode +
                    " | Qty: " +
                    option.quantity
                  }
                  getOptionSelected={(option) => option.total}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      fullWidth
                      size="small"
                      label="Returned Item"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item md={2}>
                <TextField
                  size="small"
                  type="number"
                  label="Qty"
                  variant="outlined"
                  inputProps={{
                    max: returnedItem && returnedItem.quantity,
                  }}
                  value={returnedQty}
                  onChange={(e) => {
                    setReturnedQty(e.target.value);
                  }}
                />
              </Grid>

              <Grid item md={2}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!returnedItem || returnedQty == 0 || returnedQty == ""
                    || Number(returnedItem.quantity) < Number(returnedQty)}
                  onClick={() => {
                    form.current.reportValidity() && addingReturnedItems();
                  }}
                >
                  Add
                </Button>
              </Grid>
            </Grid>
          </form>
          <div className="mt mb">
            <ReturnDataTable
              returnedDiscount={returnedDiscount}
              data={returnData}
              handleDiscountChange={handleDiscountChange}

            />
          </div>
          <div className="flex flex-end mb">
            <Button
              variant="contained"
              color="primary"
              onClick={handleReset}
              disabled={!returnData.length}
              style={{ marginRight: 5 }}
            >
              Reset
            </Button>
            <Button
              onClick={() =>
                setOpenBillPrint(true)
              }
              disabled={!returnData.length}
              // startIcon={
              //   props.isSubmitting && (
              //     <CircularProgress color="inherit" size={20} />
              //   )
              // }

              variant="contained"
              type="submit"
              color="secondary"
            >
              Save
            </Button>
            <Button onClick={() => {
              setOpenBillPrint(true)
              setSend(true)
            }}>Apply</Button>
            
            <BasicDialog
              title="Payment Receipt"
              open={openBillPrint}
              onClose={(e) => setOpenBillPrint(false)}
            >
              {!send && (
                <div>
                <span>  <Checkbox
                  label='Cash Pay'
                  onChange={handleChecked}
                />
                </span>
                <span>
                  Cash Pay
                </span>

              </div>
              )}
              
              <div className="flex">
                <button
                  disabled={disabledForSingle}
                  type="button"
                  className="btn-success button"
                  onClick={() => {
                    handleSubmit();
                    printTypeRef.current = PRINT_TYPE.POS;

                  }}
                >
                  pos bill
                  <span>
                    {loading && (
                       <CircularProgress
                       color="inherit"
                       size={20}
                      />
                    )}
                   
                  </span>
                </button>

                <button
                  type="button"
                  // disabled={
                  //   !cashPaymentValidity() || isSubmitting
                  // }
                  disabled={disabledForSingle}
                  onClick={() => {
                    handleSubmit();
                    //handlePrintDotMatrix();
                    printTypeRef.current = PRINT_TYPE.DOT_MATRIX;
                  }}
                  className="btn-success button"
                >
                  Dot matrix bill
                  <span>
                    {loading && (
                      <CircularProgress
                      color="inherit"
                      size={20} />
                    )}
                    
                  </span>
                </button>

              </div>
              <div className="flex-end">
                <Button
                  color="secondary"
                  onClick={() => {
                    setOpenBillPrint(false)
                  }}
                >
                  Close
                </Button>
              </div>
            </BasicDialog>

            <div style={{ display: "none" }}>
              <Print
                // code={invoice.code ? invoice.code : null}
                ref={computerReceiptPrintComponent}
                returnData={returnData}
                submittedData={submittedData}
                invoice={invoice}
                paymentTypes={paymentTypes}
                returnedDiscount={returnedDiscount}
              />
              <PosPrint
                ref={billReceiptPrintComponent}
                returnData={returnData}
                submittedData={submittedData}
                invoice={invoice}
                paymentTypes={paymentTypes}
                returnedDiscount={returnedDiscount}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
}